const facilities = {
  cah: {
    dinamica: {
      title: "Dinámica de Fluidos Geofísicos Computacional",
      slug: "dinamica",
      // contact: {
      //   name: "Ivonne Katherine Montes Torres",
      //   email: ["dfgc@igp.gob.pe", "imontes@igp.gob.pe"],
      //   phone: "+51 13172300",
      //   annex: "135",
      // },
      sections: [
        {
          title: "Acerca de",
          slug: "",
          name: "About",
        },
        {
          title: "Inicio del Modelado Numérico en el IGP",
          slug: "modelado-numerico",
          name: "Modeling",
        },
        {
          title: "Investigaciones",
          slug: "investigaciones",
          name: "Publications",
        },
      ],
    },
    microfisica: {
      title: "Microfísica Atmosférica y Radiación",
      slug: "microfisica",
      contact: {
        name: "José Luis Flores Rojas",
        email: ["jflores@igp.gob.pe"],
        phone: "+51 13172300",
        annex: "135",
      },
      sections: [
        {
          title: "Acerca del Observatorio Geofísico de Huancayo",
          slug: "sobre-observatorio-huancayo",
          name: "AboutHuancayo",
        },
        {
          title: "Acerca de LAMAR",
          slug: "acerca-de-lamar",
          name: "AboutLamar",
        },

        {
          title: "Instrumentación",
          slug: "instrumentos",
          name: "Instrumentos",
          subsections: [
            {
              title: "Estación Meteorológica Automática",
              slug: "estacion-meteorologica-automatica",
              name: "EstacionMeteorologicaAutomatica",
            },
            // TODO: Agregar
            {
              title: "Pluviómetro de peso",
              slug: "pluviometro-de-peso",
              name: "Pluviometro",
            },
            {
              title: "Disdrómetro",
              slug: "disdrometro",
              name: "Disdrometro",
            },
            {
              title: "Estación BSRN",
              slug: "estacion-bsrn",
              name: "EstacionBSRN",
            },

            {
              title: "Torre de gradientes",
              slug: "torre-gradientes",
              name: "TorreGradientes",
            },

            {
              title: "Radiómetro UV",
              slug: "radiometro-uv",
              name: "RadiometroUV",
            },

            {
              title: "Fotómetro Solar",
              slug: "fotometro-solar",
              name: "FotometroSolar",
            },

            {
              title: "Perfilador de aerosoles",
              slug: "perfilador-aerosoles",
              name: "PerfiladorAerosoles",
            },

            {
              title: "Ceilómetro",
              slug: "ceilometro",
              name: "Ceilometro",
            },
            {
              title: "Etalómetro",
              slug: "etalometro",
              name: "Etalometro",
            },

            {
              title: "Medidor de ozono",
              slug: "medidor-ozono",
              name: "MedidorOzono",
            },

            {
              title: "Radar de capa límite-BLTR",
              slug: "bltr",
              name: "BLTR",
            },

            {
              title: "Radar MIRA-35C",
              slug: "radar-mira-35c",
              name: "RadarMIRA35C",
            },

            {
              title: "Radar Claire",
              slug: "radar-claire",
              name: "RadarClaire",
            },
          ],
        },

        {
          title: "Monitoreo LAMAR",
          slug: "monitoreo",
          name: "Monitoreo",
          subsections: [
            {
              title: "Variables radiativas",
              slug: "variables-radiativas",
              name: "VariablesRadiativas",
            },
            {
              title: "Parámetros atmosféricos",
              slug: "registro-parametros-atmosfericos",
              name: "RegistroParametrosAtmosfericos",
            },
            {
              title: "Nubes y precipitaciones por radar",
              slug: "nubes-y-precipitaciones-por-radar",
              name: "NubesPrecipitacionesPorRadar",
            },
          ],
        },
        {
          title: "Acceso a los datos",
          path: "https://pnaig.igp.gob.pe/climadata/",
        },
        {
          title: "Publicaciones",
          slug: "publicaciones-lamar",
          name: "Publications",
          // subsections: [
          //   {
          //     title: "Material educativo",
          //     slug: "material-educativo",
          //     name: "MaterialEducativo",
          //   },
          // ],
        },
        {
          title: "Proyectos vinculados a LAMAR",
          slug: "proyectos-lamar",
          name: "Projects",
        },
      ],
    },
  },
};

function getFacilities(program) {
  return facilities[program] || facilities["cah"];
}
export { getFacilities };
